/**
 * AupPage - 可接受使用政策页（独立 AUP，Creem MoR 审核要求）。
 * 复用 LegalPage 布局，内容走 i18n legal.aup；与 terms/privacy 一样仅英文。
 */
import LegalPage from "./LegalPage";

export default function AupPage() {
  return <LegalPage i18nKey="legal.aup" />;
}
